<script setup lang="ts">
import type { Table } from '~/types/vendors/storyblok'

interface Props {
  blok: {
    content: Table
  }
}

const props = defineProps<Props>()
const blok = toRef(props, 'blok')
</script>

<template>
  <div
    v-editable="blok"
    class="container"
  >
    <table
      v-if="blok"
    >
      <thead>
        <tr>
          <th
            v-for="({ value }, index) in blok.content.thead"
            :key="`col-${index}`"
          >
            {{ value }}
          </th>
        </tr>
      </thead>
      <tbody>
        <tr
          v-for="({ body }, index) in blok.content.tbody"
          :key="`row-${index}`"
        >
          <td
            v-for="(item, key) in body"
            :key="`item-${key}`"
          >
            {{ item.value }}
          </td>
        </tr>
      </tbody>
    </table>
  </div>
</template>

<style scoped>
.container {
  overflow-x: auto;
}

table {
  width: 100%;
  border-top: 0.1rem solid var(--gray-lighter);
}

th {
  font-size: 1.2rem;
  line-height: 1.6rem;
  vertical-align: top;
  border-bottom: 0.1rem solid var(--gray-lighter);
}

td {
  border-bottom: 0.1rem solid var(--gray-lighter);
  text-align: center;
}

th, td {
  padding: 0.8rem 0 0.8rem;

}
</style>
